import { Box, Grid, Typography, Button, useTheme } from '@mui/material';
import RowContainer from '../components/RowContainer';

const Contents2 = () => {
  const { palette } = useTheme();

  const info = [
    '사용 전 설명서를 꼭 읽어주세요.',
    '아이디 : noreply@smartnurse.co.kr / nurse@smartnurse.co.kr , 비밀번호: smartnurse1  (아이디는 2개 중 하나로 선택해서 로그인해주세요.)',
    '윈도우에서만 실행이 가능합니다.',
    '관리자 권한으로 실행해야합니다.',
    '템플릿, 컨버트. 설정, 정보 네 가지 버튼이 활성화될 경우 Voice EMR이 실행되지 않습니다.',
    '사용 후 반드시 저장 정보를 삭제하고 로그아웃 후 종료해 주시기 바랍니다.',
  ];

  return (
    <>
      <RowContainer xs={12} sx={{ margin: '0px 0px 0px 20px' }}>
        <Grid
          container
          xs={11.8}
          sx={{
            backgroundColor: '#EBF8F3',
            padding: '10px',
            borderRadius: '5px',
            border: '1px solid gray',
          }}
        >
          <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'red' }}>
            ※ Voice EMR 사용방법
          </Typography>

          {info.map(a => {
            return (
              <Grid item xs={11.5}>
                <Typography sx={{ fontSize: '12px', lineHeight: '17px' }}>
                  • {a}
                </Typography>
              </Grid>
            );
          })}
        </Grid>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '97%',
            marginTop: '30px',
          }}
        >
          <Button
            variant="contained"
            onClick={() =>
              window.open(
                'https://drive.google.com/drive/folders/1Hi26L27X8aXh7seBytikUsG7yZg6u26n'
              )
            }
            sx={{
              ':hover': {
                backgroundColor: 'white',
                color: `${palette.primary.main}`,
                border: `1px solid ${palette.primary.main}`,
              },
            }}
          >
            VOICE EMR 설명서 및 프로그램 다운로드
          </Button>
        </Box>
      </RowContainer>
    </>
  );
};

export default Contents2;
